import Color from '../../Color/Color'
import Hyperlink from '../../Hyperlink/Hyperlink'
import Paragraph from '../../Paragraph/Paragraph'
import Tooltip from '../../Tooltip/Tooltip'
import classes from '../ComponentOverflow.module.scss'
import type { ReactNode } from 'react'

interface Props {
  children?: ReactNode[]
  linkTo: string
}

const OverflowHyperlink = ({
  children,
  linkTo
}: Props) =>
  <div className={classes.OverflowPlaceholder}>
    <div className={classes.Hyperlink}>
      <Hyperlink
        href={linkTo}
      >
        <Tooltip
          backgroundVariance='black'
          label='View in requirement page'
        >
          <Paragraph>
            <small>
              <Color variant='theme-description-text'>
                {
                  children && children.length < 100
                    ? `+${children.length}`
                    : '+99'
                }
              </Color>
            </small>
          </Paragraph>
        </Tooltip>
      </Hyperlink>
    </div>
  </div>

export default OverflowHyperlink
